var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"InsidePlay"},[(_vm.slug === 'pre')?_c('pre-start',{on:{"next":function($event){return _vm.next('play')}}}):_vm._e(),(_vm.slug === 'play')?_c('play',{attrs:{"lang":_vm.lang}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }